import { useContactManagementTranslation } from '../../../../../../../../ui/hooks';
import { Button } from '@mui/material';
import React from 'react';
export const AccountMembershipTableHeader = (props) => {
    const { t } = useContactManagementTranslation();
    const [allInPageSelected, setAllInPageSelected] = React.useState(() => { var _a; return !!((_a = props.selectedRowIds) === null || _a === void 0 ? void 0 : _a.length); });
    React.useEffect(() => {
        var _a;
        // setting state here because actions bellow trigger prop change
        // this will also set the correct state in scenarios like after page reload
        setAllInPageSelected(!!((_a = props.selectedRowIds) === null || _a === void 0 ? void 0 : _a.length));
    }, [props.selectedRowIds]);
    if (!props.canManageMemberships) {
        return null;
    }
    return (React.createElement(Button, { "aria-label": allInPageSelected ? t('common.selectAllRows') : t('common.deselectAllRows'), size: 'small', sx: { p: 0 }, onClick: () => {
            var _a, _b;
            if (allInPageSelected) {
                (_a = props.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(props);
            }
            else {
                (_b = props.onSelectAllRowsInCurrentPageClick) === null || _b === void 0 ? void 0 : _b.call(props, props.rows, true);
            }
        } }, allInPageSelected ? t('common.deselectAll') : t('common.selectAll')));
};
